/**
 *  update by tannc 2018年12月24日20:33:50
 */

import {
  CHECK_LOGIN_API, LOGIN_API, COMMON_STAGE_API, COMMON_SUBJECT_API, COMMON_VERSION_API
  , COMMON_TEXTBOOK_API, COMMON_EXAMHARD_API
  , USER_INFO_API, UPDATE_PWD_API, SEND_CODE_API, DEV_REDISTER_API, PASSWORD_RESET_API, COMMON_AUTH_CODE_API
  , CONTACT_US_API, GET_TOTAL_PAPER_API, GET_TOTAL_DOC_API, GET_TOTAL_QUESTION_API
  , COMMON_COLUMN_API, COMMON_GRADE_API, COMMON_EXAMTYPE_API
} from '../resource/index'

import {
  COMMON_ONE_GET,
  COMMON_ONE_SET,
  COMMON_ONE_DEAL,
  COMMON_TWO_GET,
  COMMON_TWO_SET,
  COMMON_TWO_DEAL,
  COMMON_THREE_GET,
  COMMON_THREE_SET,
  COMMON_THREE_DEAL,
} from '../resource/common';

import axios from '../config/axios.config'

export default {
  async checkLogin(username) {
    return await axios.get(CHECK_LOGIN_API, {username})
  },
  async login(params) {
    return await axios.save(LOGIN_API, {}, {
      ...params,
      // password: window.btoa(params.password)
    })
  },
  async fetchCommonStage() {
    return await axios.get(COMMON_STAGE_API, {})
  },
  async fetchCommonGrade(stage) {
    return await axios.get(COMMON_GRADE_API, {stage})
  },
  async fetchCommonSubject(id) {
    return await axios.get(COMMON_SUBJECT_API, { id })
  },
  async fetchCommonVersion(id, isAllData = false, specifyModuleId = '') {
    return await axios.get(COMMON_VERSION_API, { id, isAllData, specifyModuleId })
  },
  async fetchCommonTextbook(id, isAllData = false, specifyModuleId = '') {
    return await axios.get(COMMON_TEXTBOOK_API, { id, isAllData, specifyModuleId })
  },
  async fetchCommonColumn(stageId) {
    return await axios.get(COMMON_COLUMN_API, {
      stageId
    })
  },
  async fetchCommonExamTypes({
    gradeId = '', stageId = ''
  }) {
    return await axios.get(COMMON_EXAMTYPE_API, {gradeId, stageId})
  },
  async fetchCommonExamhard() {
    return await axios.get(COMMON_EXAMHARD_API, {})
  },
  async fetchUserInfo() {
    return await axios.get(USER_INFO_API, {})
  },
  async updatePwd(params) {
    return await axios.save(UPDATE_PWD_API, {}, params)
  },
  async senCode(mobile, imageCode = '') {
    return await axios.get(SEND_CODE_API, { mobile: mobile, imageCode: imageCode })
  },
  async getImageCode() {
    return await axios.get(COMMON_AUTH_CODE_API, {})
  },
  async devredister(params) {
    return await axios.save(DEV_REDISTER_API, {}, params)
  },
  async resetFrontPassword(params) {
    return await axios.save(PASSWORD_RESET_API, {}, params)
  },
  async contractUs(params) {
    return await axios.save(CONTACT_US_API, {}, params)
  },
  getDocumentNum() {
    return axios.get(GET_TOTAL_DOC_API, {})
  },
  getQuestionNum() {
    return axios.get(GET_TOTAL_QUESTION_API, {})
  },
  getPaperNum() {
    return axios.get(GET_TOTAL_PAPER_API, {})
  },
  /**
  * @description: 获取通用标签(一级+)
  * @return {*}
  */
  async common_tag_get(level = 'one', params = {}) {
    let map = {
      'one': COMMON_ONE_GET,
      'two': COMMON_TWO_GET,
      'three': COMMON_THREE_GET
    }
    return await axios.save(map[level], {}, params);
  },
  /**
   * @description: 修改通用标签(一级+)
   * @param {*} level
   * @param {*} params
   * @return {*}
   */
  async common_tag_set(level = 'one', params) {
    let map = {
      'one': COMMON_ONE_SET,
      'two': COMMON_TWO_SET,
      'three': COMMON_THREE_SET
    }
    return await axios.save(map[level], {}, params);
  },
  /**
   * @description: 启用和禁用通用标签(一级)
   * @param {*} id
   * @param {*} type
   * @return {*}
   */
  async common_tag_deal(level = 'one', params) {
    let map = {
      'one': COMMON_ONE_DEAL,
      'two': COMMON_TWO_DEAL,
      'three': COMMON_THREE_DEAL
    }
    return await axios.update(map[level], params, {});
  }
}



// WEBPACK FOOTER //
// ./src/service/commonService.js